export const APP_URLS = {
  home: '/',

  // Auth Urls
  signIn: '/signin',
  signUp: '/signup',
  forgotPassword: '/forgot-password',
  verify: '/verify',
  resetPassword: '/reset-password',
  accountStatus: '/accounts/status',

  // Student Dashboard / Profile Urls
  profile: '/student/:studentSlug/profile',
  familyInfo: '/student/:studentSlug/profile/family',
  educationInfo: '/student/:studentSlug/profile/education',
  achievementInfo: '/student/:studentSlug/profile/achievement',
  workInfo: '/student/:studentSlug/profile/work',
  wishlistInfo: '/student/:studentSlug/profile/wishlist',
  documentInfo: '/student/:studentSlug/profile/document',
  applicationInfo: '/student/:studentSlug/profile/application',
  editProfile: '/student/:studentSlug/profile/edit',
  editFamilyInfo: '/student/:studentSlug/profile/family-edit',
  editEducationInfo: '/student/:studentSlug/profile/education-edit',
  editAchievementInfo: '/student/:studentSlug/profile/achievement-edit',
  editWorkInfo: '/student/:studentSlug/profile/work-edit',
  editDocumentInfo: '/student/:studentSlug/profile/document-edit',
  editSkills: '/student/:studentSlug/profile/skills-edit',
  editPassword: '/student/:studentSlug/profile/reset-password',
  applyToMultiplePrograms: '/student/:studentSlug/profile/apply-programs',
  applyToMultipleScholarships: '/student/:studentSlug/profile/apply-scholarships',
  deleteAccount: '/student/:studentSlug/profile/delete',

  // Institutes url
  institutes: '/institutes',
  singleInstitute: '/institutes/:instituteSlug',
  singleProgram: '/institutes/:instituteSlug/programs/:programSlug',

  // Scholarships url
  scholarships: '/scholarships',
  singleScholarship: '/scholarships/:scholarshipSlug',

  // Admin registration urls
  academicAdminRegister: '/register-academic-admin',
  scholarshipAdminRegister: 'register-scholarship-admin',
  adminRegisterSuccess: '/register-admin-success',

  // Programs url
  programs: '/programs',

  // Course url
  singleCourse: '/institutes/:instituteSlug/programs/:programSlug/:courseId',

  // About urls
  contact: '/contact-us',
  privacyPolicy: '/privacy-policy',
  termsOfService: '/terms-of-service',

  // News urls
  news: '/news',
  singleNews: '/news/:newsSlug',

  // Eligible urls
  eligibleModules: '/eligible',
  eligibleInstitutes: '/eligible/institutes',
  eligiblePrograms: '/eligible/programs',
  eligibleScholarships: '/eligible/scholarships',

  // Routines
  routines: '/routines',
  singleRoutine: '/routines/:routineSlug',

  // Results
  see2079Result: '/results/see-2079',
};

export const API_URLS = {
  // Landing Page Urls
  sliders: 'sliders',
  registeredStatistics: 'registered-statistics',
  featuredInstitutes: 'featured-institutes',
  latestFeaturedNews: 'news/homepage/:timeInSeconds',

  // Common Urls
  siteSettings: 'site-settings',
  menus: 'menus',
  educationLevels: 'education-levels',

  // Authentication and Authorization Urls
  signIn: 'login',
  signUp: 'register',
  resendActivationLink: 'resend-activation-link',
  verify: 'verify/student',
  socialAuth: 'social-login',
  forgotPassword: 'password/send-reset-password-link',
  verifyForgotPasswordHash: 'password/verify',
  resetForgotPassword: 'password/reset-password',
  socialAccountStatus: 'social/accounts/status',

  // User Profile Urls
  signInUserWithToken: 'user',
  getProfile: 'students/:slug/profile',
  updateProfilePicture: 'students/:slug/picture',
  updateSkill: 'students/:slug/skill',
  updateFamily: 'students/:slug/family-detail',
  updatePassword: 'students/:slug/password',
  updateAchievement: 'students/:slug/achievement',
  updateExperience: 'students/:slug/experience',
  addToWishlist: 'students/:slug/wishlist',
  removeFromWishlist: 'students/:slug/wishlist/remove',
  educationFormOptions: 'students/education-api-essentials',
  educationFormProgramOptions: 'institute-parent-programs',
  educationFormOptionsByProgram: 'data-for-student-education-api',
  updateEducation: 'students/:slug/education-detail',
  createInstituteForEducation: 'students/:slug/create-institute',
  updateDocument: 'students/:slug/document',
  profileFormOptions: 'students/profile-form-data',
  updateProfile: 'students/:slug/profile/update',
  educationEligibility: 'student/:slug/education',
  applyForProgramsOrScholarships: 'students/:slug/apply',
  deleteAccount: 'students/:slug/delete',

  // Institutes
  institutes: 'institutes',
  singleInstitute: 'institute/:instituteSlug',
  eligibleInstitutesData: 'eligible-institutes-data',
  institutesByIds: 'institute-by-ids',

  // Scholarships
  scholarships: 'scholarships',
  scholarshipPage: 'scholarship-page',
  singleScholarship: 'scholarship/:scholarshipSlug',
  eligibleScholarshipIds: 'eligible-scholarship-ids',
  scholarshipByIds: 'scholarship-by-ids',

  // Course
  singleCourse: 'institute/:instituteSlug/program/:programSlug/:courseId',

  // Institute types
  instituteTypes: 'institute-types',

  // Programs
  programs: 'programs',
  singleProgram: 'institute/:instituteSlug/program/:programSlug',
  featuredPrograms: 'programs/featured',
  eligibleProgramIds: 'eligible-program-ids',
  programsByIds: 'program-by-ids',

  // Eligibilities
  getEligibilities: 'get-eligibilities',

  // Admin Register
  scholarshipProviderRegister: 'organization/scholarship-provider-register',
  academicAdminRegister: 'organization/institute-register',

  // News
  news: 'news',
  singleNews: 'news/single/:newsSlug',

  // Others
  feedback: 'feedback',

  // Qualifications
  qualificationOptions: 'qualification-options',
  qualificationByEmail: 'qualifications/:email',
  upsertQualification: 'qualification-upsert',

  // Routines
  routines: 'routines',
  singleRoutine: 'routines/:routineSlug',
};
